import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssSwitch extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 2 ********************************************////
    protected isDisabled?: boolean = false;
    protected isReadonly?: boolean = false;
    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected isChecked?: boolean = false;
    protected label: string = 'switch';

    protected toggleIsChecked(value: boolean): void {
        this.isChecked = value;
    }

    protected toggleIsDisabled(value: boolean): void {
        this.isDisabled = value;
    }

    protected toggleIsReadonly(value: boolean): void {
        this.isReadonly = value;
    }

    protected handleChangeLabel(value: string): void {
        this.label = value;
    }

}
